import { useState, useEffect, useMemo } from 'react';
import { usersGetLoginNetworkService } from 'services/user';
import { branchnetworkListService } from 'services/branchnetwork';

export function useRackDiagramBreadcrumb(tailLabel, tailPath = '') {
  const [locationLabel, setLocationLabel] = useState('');

  useEffect(() => {
    Promise.all([
      usersGetLoginNetworkService(),
      branchnetworkListService(),
    ])
      .then(([loginResponse, listResponse]) => {
        const loginItem = loginResponse.data.item;
        const locationId =
          loginItem?.branchnetwork?._id || loginItem?.branchnetwork;

        const fromLogin =
          loginItem?.branchnetwork?.branch?.branch_name ||
          loginItem?.branchnetwork?.branch_name;

        if (fromLogin) {
          setLocationLabel(fromLogin);
          return;
        }

        const networks = listResponse.data.items || [];
        const match = networks.find(
          (n) => String(n._id) === String(locationId),
        );
        if (match?.branch?.branch_name) {
          setLocationLabel(match.branch.branch_name);
        }
      })
      .catch(() => {});
  }, []);

  return useMemo(() => {
    const items = [
      { label: 'Home', path: '/' },
      { label: 'Network Management', path: '/network-dashboard' },
      { label: 'Rack Diagram', path: '/rackregistry' },
    ];
    if (locationLabel) {
      items.push({ label: locationLabel, path: '' });
    }
    if (tailLabel) {
      items.push({ label: tailLabel, path: tailPath });
    }
    return items;
  }, [locationLabel, tailLabel, tailPath]);
}
